module.exports = __webpack_public_path__ + "chat-bg.b04e814510747fb82cb1.jpg";


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/assets/images/chat-bg.jpg
// module id = ../../../../../src/assets/images/chat-bg.jpg
// module chunks = styles